

import { Component } from 'react';
import service from '../../core/service';


interface IProps {

}

interface IState {
    str:string;
    value:string,
    openModal:boolean,
    openActionModal:boolean;
    consultationRequest:any;
    page: number;
    loading?:boolean;
}

export class ConsultationRequestController extends Component<IProps, IState> {
    state: IState = {
        str:"",
        value:"",
        openModal:false,
        openActionModal:false,
        consultationRequest:[],
    page: 1,
    loading:false
       
    };

    search = async (e:any) => {
        this.setState({ str: e })
    };
    handleChange = (e:any) => {
        this.setState({ value: e.target.value })
    };
    paginationTimeOut: string | number | NodeJS.Timeout | undefined;
    handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
        this.setState({ page: value })
        clearTimeout(this.paginationTimeOut);
        this.paginationTimeOut = setTimeout(() => {
            this.getList()
        }, 800);
    }
    getList = async (): Promise<void> => {
        this.setState({ loading: true });
        const { page } = this.state;
    
        let parameters = {
          page: page ? page.toString() : "1",
        //   count: count ? count.toString() : "10",
        };
    
        const params = new URLSearchParams();
    
        for (const [key, value] of Object.entries(parameters)) {
          if (value) {
            params.append(key, value);
          }
        }
    
        try {
          const response = await service.ConsultationRequest.list(this.state.page);
          if (response) {
            this.setState({ consultationRequest: response?.data?.data?.data })
            this.setState({ loading: false })
          }else{
            this.setState({ loading: false })
          }
        } catch (error) {
          this.setState({ loading: false });
        }
      };
    
    
}
export default ConsultationRequestController;